import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import { Accordion } from '@mui/material';
import { AccordionSummary } from '@mui/material';
import { AccordionDetails } from '@mui/material';
import classNames from 'classnames';
import { AvenyThemeShapeBorderRadius } from '../../ThemeProvider/AvenyTheme';

interface IProps {
  expanded: boolean;
  onChange: (event: any, newValue: boolean) => void;
  disabled?: boolean;
  label?: React.ReactNode;
  children?: React.ReactNode | ComponentFunc;
  elevation?: number;
  changeSummaryStyleWhenExpanded?: boolean;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
}

const styles = (theme: Theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  summary: {
    borderRadius: AvenyThemeShapeBorderRadius / 2,
    margin: theme.spacing(1, 0),
    backgroundColor: theme.customProperties.MessageList.readBackground,
    color: theme.customProperties.MessageList.readMessageTextHi,
  },

  /*Styles applied to the root element.*/
  root: {
    width: '100%',
  },

  /*Styles applied to the root element.*/
  summaryRoot: {},

  /*Styles for the summary content*/
  summaryContent: {
    '& >:last-child': {
      paddingRight: 8,
    },
  },

  /*Styles for the expanded summary*/
  summaryExpanded: {
    margin: theme.spacing(2, 0),
  },

  /*Styles applied to the root element.*/
  detailsRoot: {},
});

type ComponentFunc = () => React.ReactNode;

/**
 * Specifik implementation av expansionpanelen
 */
export class EDMessageExpansionPanel extends React.PureComponent<IProps> {
  evalChildren = (children: React.ReactNode | ComponentFunc, open: boolean) => {
    const classes = withStyles.getClasses(this.props);
    if (typeof children === 'function') {
      if (open) {
        return (
          <AccordionDetails
            style={{ width: '100%' }}
            classes={{ root: classes.detailsRoot }}
          >
            {(children as ComponentFunc)()}
          </AccordionDetails>
        );
      } else {
        return null;
      }
    } else {
      return (
        <AccordionDetails
          style={{ flexWrap: 'wrap' }}
          classes={{ root: classes.detailsRoot }}
        >
          {children || <div />}
        </AccordionDetails>
      );
    }
  };

  render() {
    let { label } = this.props;
    const classes = withStyles.getClasses(this.props);
    return (
      <Accordion
        elevation={this.props.elevation}
        expanded={this.props.expanded}
        disabled={this.props.disabled}
        onChange={this.props.onChange}
        TransitionProps={{
          mountOnEnter: true,
          unmountOnExit: true,
        }}
        classes={{
          root: classes.root,
        }}
      >
        <AccordionSummary
          component="div"
          classes={{
            root: classes.summaryRoot,
            content: classes.summaryContent,
            expanded: classes.summaryExpanded,
          }}
          className={classNames({
            [classes.summary]:
              this.props.changeSummaryStyleWhenExpanded && this.props.expanded,
          })}
        >
          {label}
        </AccordionSummary>
        {this.evalChildren(this.props.children, this.props.expanded)}
      </Accordion>
    );
  }
}

// Om du vill hantera expanded och onChange utifrån
export const EDStyledMessageExpansionPanel = withStyles(
  EDMessageExpansionPanel,
  styles
);
